<template>
  <div class="activities-overlay">
    <div class="top-bar">
      <button class="btn back-button" v-on:click="closeClicked"><span></span></button>
      <div class="title-bar">
        <div class="title">BEWEEG TUSSENDOOR</div>
      </div>
    </div>

    <transition appear name="bounce">
      <div v-show="open" class="activity-detail-wrapper">
        <div class="header-bar"></div>

        <div v-if="quest?.id === undefined" class="info-window">
          <div class="header"></div>

          <div class="info-content">

            <p class="description">Heb je een Beweeg Tussendoortje uitgevoerd uit het fysieke kaartspel, vul dan
              hieronder de code in.</p>
            <div class="text-input-wrapper">
              <p class="description">Beweeg Tussendoor code</p>
              <input type="text" v-model="code" class="code-input text-input" placeholder="">
            </div>
            <p class="description">Heb je nog geen fysiek kaartspel, vraag dit dan aan via <a
                href="https://www.moev.be/materialen/beweegbuddy-kaartspel">deze link</a>.</p>
            <p class="error-text">{{ errorText }}</p>
          </div>
          <div class="footer"></div>

          <div class="button-row">
            <WhiteOutlineButton :buttonText="'CODE INGEVEN'" :stretch-to-fill="true"
                                v-on:clicked="enterCodeClicked"></WhiteOutlineButton>
          </div>
        </div>

        <div v-if="quest?.id !== undefined" class="info-window">
          <div class="header"></div>

          <div class="info-content">

            <!--Quest media item-->
            <div class="row image mt-3"
                 v-if="quest.mediaItem && quest.mediaItem.type !== mediaItemTypeEnum.none">
              <div class="col">
                <div class="activity-image"
                     v-if="quest.mediaItem.type === mediaItemTypeEnum.image && quest.mediaItem.imageAsset">
                  <img class="img-fluid" :src="quest.mediaItem.imageAsset.url" alt="Activiteit afbeelding"/>
                </div>
                <div class="embed-responsive embed-responsive-16by9 activity-video"
                     v-if="quest.mediaItem.type === mediaItemTypeEnum.video && quest.mediaItem.videoUrl">
                  <iframe class="embed-responsive-item"
                          :src="convertYoutubeUrlToEmbedUrl(quest.mediaItem.videoUrl)"
                          title="YouTube video player"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowfullscreen></iframe>
                </div>
              </div>
            </div>
            <div class="description">
              <p>{{ quest.descriptionTeacher }}</p>

              <div v-if="quest.format === 'quiz'">
                <div :key="question" v-for="question in quest.quizQuestions">
                  <p>{{ question.phrase }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="footer"></div>

          <div class="button-row space-between">
            <WhiteOutlineButton :buttonText="'TERUG'"
                                v-on:clicked="returnToCodeInputClicked"></WhiteOutlineButton>
            <WhiteOutlineButton :buttonText="'ACTIVITEIT UITGEVOERD'"
                                v-on:clicked="activityCompleteClicked"></WhiteOutlineButton>
          </div>
        </div>

      </div>
    </transition>
  </div>
</template>

<script>

import QuestTypeHelper from "@/mixins/QuestTypeHelper";
import { QuestApi, QuestFormatEnum, QuestMediaTypeEnum, QuestTypeEnum } from "sandpiper_api";
import WhiteOutlineButton from "@/components/StudentPlatform/WhiteOutlineButton";
import YoutubeVideoEmbedder from "@/mixins/YoutubeVideoEmbedder";
import QuestPropertiesHelper from "@/mixins/QuestPropertiesHelper";


export default {
  name: "ImpulseCodeOverlay",
  components: { WhiteOutlineButton },
  emits: [ "enterCodeClicked", "backClicked" ],
  mixins: [ QuestPropertiesHelper, QuestTypeHelper, YoutubeVideoEmbedder ],

  inject: [ "doApiRequest" ],
  props: {
    name: String,
    open: Boolean,
  },
  watch: {
    open: {
      handler()
      {
        if (this.open)
        {
          this.quest = null;
        }
      },
      deep: true,
    },
  },
  data()
  {
    return {
      show: this.open,
      mediaItemTypeEnum: new QuestMediaTypeEnum(),
      questFormatEnum: new QuestFormatEnum(),
      questTypeEnum: new QuestTypeEnum(),
      quest: null,
      startedActivityIndex: 0,
      code: null,
      errorText: "",

    }
  },
  computed: {},
  methods: {

    closeClicked()
    {
      this.$emit("closeClicked", true);
    },

    async enterCodeClicked()
    {
      this.quest = await this.getQuest();

    },
    activityCompleteClicked()
    {
      this.$emit("enterCodeClicked", this.quest);

    },
    returnToCodeInputClicked()
    {
      this.quest = null;
    },
    async getQuest()
    {
      try
      {
        this.errorText = "";

        if (this.code.charAt(0) === "#")
        {
          this.code = this.code.substring(1);
        }
        return await this.doApiRequest(() => new QuestApi().getQuestByCardCode(this.code));
      }
      catch (e)
      {
        this.errorText = "Er is geen activiteit gevonden met deze code";
        console.error("Failed to fetch quests - %o", e);
      }
    },

  },
  mounted()
  {

  },
  created()
  {

  },
}


</script>

<style lang="scss" scoped>

@mixin aspect-ratio($width, $height) {
  position: relative;
  &:before {
    display: block;
    content: "";
    width: 100%;
    padding-top: ($height / $width) * 100%;
  }
  > .content {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
}

.activities-overlay {
  width: 100vw;
  height: 100vh;
  position: absolute;
  background-color: rgb(37, 38, 66);
  z-index: 9999;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.top-bar {
  height: 150px;
  width: 100%;
  display: flex;
  justify-content: center;
}

.activity-detail-wrapper {
  height: calc(100vh - 150px);
  display: flex;
  justify-content: center;
  width: 100%;
  overflow-y: scroll;
  background-image: url("~@/assets/image/platform/background/activity_bg.svg");


  .header-bar {
    width: 100%;
    background-image: url("~@/assets/image/platform/background/activity_border.svg");
    background-repeat: no-repeat;
    background-size: 100vw;
    background-position: top center;
    padding-top: 6%;

    position: absolute;
    z-index: 2;
  }
}

.back-button {
  width: 100px;
  height: 100px;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  left: 50px;
  top: 25px;
  background-image: url("~@/assets/image/button/bb_button_square.svg");

  span {
    display: block;
    width: 70%;
    height: 70%;
    background-image: $back-icon;
    background-position: center;
    background-size: contain;
  }

}

.title-bar {
  width: 600px;
  height: 100px;
  position: absolute;
  top: 3vh;
  background-image: url("~@/assets/image/bb_frame-title.svg");
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center center;
  align-self: center;

  display: flex;
  align-items: center;


  .icon {
    position: absolute;
    width: 60px;
    height: 60px;
    left: 20px;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
  }

  .title {
    align-self: center;
    margin: 0px 100px;
    width: 100%;
    text-align: center;
    font-weight: bold;
    font-size: 2rem;
    color: white;
  }
}


.bounce-enter-active {
  animation: bounce-in 1s;
}

.bounce-leave-active {
  animation: bounce-in .5s reverse;
}

@keyframes bounce-in {
  0% {
    transform: translateY(100vh);
  }
  50% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(0);
  }
}

.info-window {
  //width: 50%;
  flex: 100%;
  max-width: 700px;
  position: relative;
  margin: 100px;

  .header {
    background-image: url("~@/assets/image/platform/frame/frame_medium_top.svg");
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: bottom center;
    height: min(5vw, 11vh);
    top: 1px;
    position: relative;
  }

  .info-content {
    background-image: url("~@/assets/image/platform/frame/frame_medium_mid.svg");
    background-size: 100%;
    background-position: center center;
    position: relative;
    padding: 25px 50px;

  }

  .footer {
    background-image: url("~@/assets/image/platform/frame/frame_medium_bot.svg");
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: top center;
    height: min(5vw, 11vh);
  }

}

.close-button {
  width: 50px;
  height: 50px;
  position: absolute;
  right: 2%;
  top: 2%;
  background-image: url("~@/assets/image/button/bb_button_close.svg");
}

.title {
  font-size: 2rem;
  font-weight: bold;
  color: white;
  text-align: center;
}

.description {
  margin-top: 30px;
  color: white;

  p {
    color: white;
    white-space: pre-line;
  }

}

.text-input-wrapper {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;

  p {
    margin: 0 5px;
  }

  input {
    font-weight: bold;
  }
}

.button-row {
  height: 15%;
  display: flex;
  flex-direction: row;
  justify-content: center;

  &.space-between {
    justify-content: space-between;
  }
}

.error-text {
  color: darkred;
}

</style>